import styles from "@/pages/saleOperations/saleWorkBench/customerDetail/index.module.less";
import classNames from "classnames";
import dayjs from "dayjs";

const RecordItem = ({item}) => {
  return <>
    <div className={styles.recordBox}>
      <p className={classNames([styles.mb10, styles.time])}>{dayjs(item.createdTime).format('YYYY-MM-DD HH:mm:ss')}</p>
      <p className={classNames([styles.flexStart, styles.mb10])}>
        <span className={styles.label}>操作：</span>
        <span className={styles.tag}>{item.followerTypeName}</span>
      </p>
      <p className={classNames([styles.flexStart, styles.mb10])}>
        <span className={styles.label}>跟进人：</span>
        <span className={styles.value}>{item.name}</span>
      </p>
      {item.beforeStatusName !== item.afterStatusName && <p className={classNames([styles.flexStart, styles.mb10])}>
        <span className={styles.label}>状态变更：</span>
        <span className={styles.value}>{item.beforeStatusName} --&gt; {item.afterStatusName}</span>
      </p>}
      <p className={classNames([styles.flexStart, styles.mb10])}>
        <span className={styles.label}>跟进内容：</span>
        <span className={styles.value}>{item.content}</span>
      </p>
    </div>
  </>
}

export default RecordItem